import styled from 'styled-components';
import { hidden } from '../../styles/globalStyles';

export const Main = styled.main`
  flex: 1 0 auto;
`;

export const Container = styled.div`
  max-width: 360px;
  margin: 0 auto;
  padding-top: 72px;

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    max-width: 704px;
    padding-top: 80px;
  }

  @media screen and (min-width: 1280px) {
    max-width: 1280px;
    padding-top: 88px;
  }
`;

export const AppTitle = styled.h1`
  ${hidden}
`;
